module.exports = __webpack_public_path__ + "img/mars-stroke-v.dbc44f07.svg";